if (!customElements.get("m-why-join-celesty-umt")) {
  class MWhyJoinCelestyUMT extends HTMLElement {
    constructor() {
      super();
      this.handleBlockSelect = this.handleBlockSelect.bind(this);
    }

    connectedCallback() {
      document.addEventListener("shopify:block:select", this.handleBlockSelect);
    }

    disconnectedCallback() {
      document.removeEventListener("shopify:block:select", this.handleBlockSelect);
    }

    handleBlockSelect(event) {
      const block = event.target;
      if (!block || !this.contains(block)) return;

      const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

      block.scrollIntoView({
        behavior: prefersReducedMotion ? "auto" : "smooth",
        block: "nearest",
        inline: "nearest"
      });
    }
  }

  customElements.define("m-why-join-celesty-umt", MWhyJoinCelestyUMT);
}